import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import './Policies.css';

const policies = [
  {
    id: 'shipping',
    title: 'Shipping Policy',
    icon: '🚚',
    lastUpdated: 'April 2025',
    sections: [
      {
        heading: 'Delivery Zone',
        content: 'Our delivery services are currently only available to locations within continental India.',
      },
      {
        heading: 'Shipping Rates & Processing Time',
        content: 'Please allow 1–3 business days (Monday–Saturday) of processing time before your order is dispatched.\n\nShipping rates:\n• Economy – India: 5 to 7 business days (Mon–Sat) at a standard rate of ₹80 per KG\n\nFree shipping is available on most products. Please check the individual product page for specific shipping details.',
      },
      {
        heading: 'How Do I Check the Status of My Order?',
        content: 'When your order has shipped, you will receive an email notification with a tracking number you can use to check its status. Please allow 48 hours for the tracking information to become available.\n\nIf you haven\'t received your order within 10 days of receiving your shipping confirmation email, please contact us at fcreation08@gmail.com or +91 6355 592849 with your name and order number, and we will investigate for you.',
      },
      {
        heading: 'Item Not Received',
        content: 'If you\'ve successfully placed an order and haven\'t received it, but the tracking status shows it as delivered, please contact the carrier first. Once the item is with the carrier, we have limited control over the delivery. If the issue persists, please email us at fcreation08@gmail.com or contact us at +91 6355 592849.',
      },
      {
        heading: 'Change of Address',
        content: 'We cannot change the delivery address once the order is in transit. If you need to change your delivery address, please contact us within 12 hours of placing your order at +91 6355 592849.',
      },
      {
        heading: 'Cancellations',
        content: 'We do not accept cancellation orders once they are confirmed. Since all our products are personalised, production begins immediately after order confirmation.\n\nFor any help, contact us:\n• Email: fcreation08@gmail.com\n• Phone/WhatsApp: +91 6355 592849',
      },
    ],
  },
  {
    id: 'returns',
    title: 'Returns & Exchange',
    icon: '↩️',
    lastUpdated: 'April 2025',
    sections: [
      {
        heading: 'Our Returns Policy',
        content: 'Since your product is customised to your specific requirements, we do not accept returns or exchanges.\n\n⚠️ A product opening video is mandatory for any claim. The video must be uncut and without any pause from the moment you begin opening the package. Without this video, we will be unable to process your claim.',
      },
      {
        heading: 'When Is a Return Eligible?',
        content: 'A product is only eligible for return under the following conditions:\n\n1) A wrong product has been dispatched and the product does not match the item selected during order confirmation.\n\n2) You identify a quality or manufacturing defect on the received product.\n\n3) The product is received in a damaged condition.',
      },
      {
        heading: 'What Happens After a Return Is Approved?',
        content: 'If the product is wrongfully delivered (doesn\'t match the order confirmation) or has a genuine quality/manufacturing defect, we extend options for:\n• Full refund to your original payment method, OR\n• Re-fulfilment of your order (replacement)\n\nPlease contact us immediately at fcreation08@gmail.com or WhatsApp +91 63555 92849 with your order number and the product opening video.',
      },
      {
        heading: 'Refund Policy',
        content: 'Due to the personalised nature of our customised products, all sales are final and we cannot offer refunds or exchanges unless the product qualifies under the return conditions above.\n\nIf a refund is approved, it will be processed to your original payment method within 5–7 business days.',
      },
    ],
  },
  {
    id: 'privacy',
    title: 'Privacy Policy',
    icon: '🔒',
    lastUpdated: 'April 2025',
    sections: [
      {
        heading: 'Section 1 – What Do We Do With Your Information?',
        content: 'When you purchase something from our store, as part of the buying and selling process, we collect the personal information you give us — such as your name, address, and email address.\n\nEmail marketing (if applicable): With your permission, we may send you emails about our store, new products, and other updates.',
      },
      {
        heading: 'Section 2 – Consent',
        content: 'When you provide us with personal information to complete a transaction, verify your credit card, place an order, arrange for a delivery, or return a purchase, we imply that you consent to our collecting it and using it for that specific reason only.\n\nIf we ask for your personal information for a secondary reason, like marketing, we will either ask you directly for your expressed consent, or provide you with an opportunity to say no.\n\nTo withdraw your consent: If after you opt-in, you change your mind, you may withdraw your consent for us to contact you at anytime by contacting us at fcreation08@gmail.com.',
      },
      {
        heading: 'Section 3 – Disclosure',
        content: 'We may disclose your personal information if we are required by law to do so, or if you violate our Terms of Service.',
      },
      {
        heading: 'Section 4 – Payment',
        content: 'We use Razorpay for processing payments. We/Razorpay do not store your card data on their servers. The data is encrypted through the Payment Card Industry Data Security Standard (PCI-DSS) when processing payment. Your purchase transaction data is only used as long as is necessary to complete your purchase transaction.\n\nOur payment gateway adheres to the standards set by PCI-DSS as managed by the PCI Security Standards Council — a joint effort of brands like Visa, MasterCard, American Express, and Discover.\n\nFor more information, you may also read Razorpay\'s terms and conditions at razorpay.com.',
      },
      {
        heading: 'Section 5 – Third-Party Services',
        content: 'Third-party service providers used by us will only collect, use, and disclose your information to the extent necessary to perform the services they provide to us.\n\nCertain third-party service providers, such as payment gateways, have their own privacy policies regarding the information we are required to provide for purchase-related transactions. We recommend reading their privacy policies.',
      },
      {
        heading: 'Section 6 – Security',
        content: 'To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered, or destroyed.',
      },
      {
        heading: 'Section 7 – Cookies',
        content: 'We use cookies to maintain session of your user account. Cookies are not used to personally identify you on other websites.',
      },
      {
        heading: 'Section 8 – Age of Consent',
        content: 'By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you have given consent to allow any of your minor dependents to use this site.',
      },
      {
        heading: 'Section 9 – Changes to This Privacy Policy',
        content: 'We reserve the right to modify this privacy policy at any time. Changes will take effect immediately upon posting on the website. If we make material changes, we will notify you on this page.\n\nQuestions? Contact our Privacy Compliance Officer at fcreation08@gmail.com.',
      },
    ],
  },
  {
    id: 'terms',
    title: 'Terms & Conditions',
    icon: '📄',
    lastUpdated: 'April 2025',
    sections: [
      {
        heading: 'Overview',
        content: 'This website is operated by F CREATION GIFTING STUDIO. Throughout the site, the terms "we", "us" and "our" refer to F CREATION GIFTING STUDIO.\n\nBy visiting our site and/or purchasing something from us, you engage in our "Service" and agree to be bound by the following terms and conditions, including those additional terms and conditions and policies referenced herein.\n\nPlease read these Terms of Service carefully before accessing or using our website.',
      },
      {
        heading: 'Section 1 – Online Store Terms',
        content: 'By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or province of residence.\n\nYou may not use our products for any illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction (including but not limited to copyright laws).\n\nYou must not transmit any worms, viruses, or any code of a destructive nature.\n\nA breach or violation of any of the Terms will result in an immediate termination of your Services.',
      },
      {
        heading: 'Section 2 – General Conditions',
        content: 'We reserve the right to refuse service to anyone for any reason at any time.\n\nYou agree not to reproduce, duplicate, copy, sell, resell, or exploit any portion of the Service without express written permission by us.',
      },
      {
        heading: 'Section 3 – Accuracy, Completeness & Timeliness of Information',
        content: 'We are not responsible if information made available on this site is not accurate, complete, or current. The material on this site is provided for general information only and should not be relied upon as the sole basis for making decisions.\n\nWe reserve the right to modify the contents of this site at any time.',
      },
      {
        heading: 'Section 4 – Modifications to the Service & Prices',
        content: 'Prices for our products are subject to change without notice.\n\nWe reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice.\n\nWe shall not be liable to you or any third-party for any modification, price change, suspension, or discontinuance of the Service.',
      },
      {
        heading: 'Section 5 – Products or Services',
        content: 'We have made every effort to display product colours and images as accurately as possible. We cannot guarantee that your computer monitor\'s display of any colour will be accurate.\n\nWe reserve the right to limit or cancel quantities purchased per person, per household, or per order.',
      },
      {
        heading: 'Section 6 – Accuracy of Billing & Account Information',
        content: 'We reserve the right to refuse any order you place with us.\n\nYou agree to provide current, complete, and accurate purchase and account information for all purchases made at our store.',
      },
      {
        heading: 'Section 12 – Prohibited Uses',
        content: 'You are prohibited from using the site or its content for any unlawful purpose; to infringe upon intellectual property rights; to harass, abuse, or discriminate; to submit false or misleading information; to upload or transmit viruses or malicious code; or to interfere with the security features of the Service.',
      },
      {
        heading: 'Section 13 – Disclaimer of Warranties & Limitation of Liability',
        content: 'We do not guarantee that your use of our service will be uninterrupted, timely, secure, or error-free.\n\nIn no case shall F CREATION GIFTING STUDIO be liable for any injury, loss, claim, or any direct, indirect, incidental, punitive, or consequential damages of any kind arising from your use of our service or products.',
      },
      {
        heading: 'Section 14 – Indemnification',
        content: 'You agree to indemnify, defend, and hold harmless F CREATION GIFTING STUDIO and our affiliates, partners, officers, directors, agents, and employees from any claim or demand, including reasonable attorneys\' fees, made by any third-party due to your breach of these Terms of Service.',
      },
      {
        heading: 'Contact Information',
        content: 'Questions about the Terms of Service should be sent to:\n• Email: fcreation08@gmail.com\n• Phone/WhatsApp: +91 63555 92849',
      },
    ],
  },
  {
    id: 'policies',
    title: 'General Policies',
    icon: '📋',
    lastUpdated: 'April 2025',
    sections: [
      {
        heading: 'Returns / Exchange Policy',
        content: 'Since your product is customised to your requirements, we do not accept returns/exchange.\n\n⚠️ Must required product opening video for claim without cut & pause.\n\nA product is only eligible for return under the following conditions:\n\n1) A wrong product has been dispatched and does not match the item selected during order confirmation.\n\n2) If you identify a quality or manufacturing defect on the received product.\n\n3) If the product is received in a damaged condition.\n\nHowever, if the product is wrongfully delivered or has a genuine quality/manufacturing defect, we extend options for full refund or re-fulfilment of your orders!',
      },
      {
        heading: 'Shipping Policy',
        content: 'We have stopped accepting Cash on Delivery. Please use our other available modes of payment to place your order.\n\nFree shipping is available on most products across India. Delivery takes 6–8 working days including making and shipping time.',
      },
      {
        heading: 'Refund Policy',
        content: 'Due to the personalised nature of our customised products, all sales are final and we cannot offer refunds or exchanges.\n\nRefunds are only processed in cases of wrong product delivery, manufacturing defects, or damaged goods — subject to a valid product opening video being provided.',
      },
    ],
  },
];

const PolicySection = ({ section }) => {
  const renderContent = (text) =>
    text.split('\n').map((line, i) => {
      if (!line.trim()) return null;
      if (line.startsWith('⚠️')) return (
        <div key={i} className="policy-warning">
          <span>⚠️</span>
          <span>{line.replace('⚠️', '').trim()}</span>
        </div>
      );
      if (line.match(/^\d+\)/) || line.match(/^•/)) return (
        <p key={i} className="policy-bullet">
          <span className="policy-bullet-dot">{line.match(/^\d+\)/) ? line.match(/^\d+\)/)[0] : '•'}</span>
          <span>{line.replace(/^\d+\)|^•/, '').trim()}</span>
        </p>
      );
      const parts = line.split(/\*\*(.*?)\*\*/g);
      return (
        <p key={i} className="policy-para">
          {parts.map((part, j) => j % 2 === 1 ? <strong key={j}>{part}</strong> : part)}
        </p>
      );
    });

  return (
    <div className="policy-section">
      <h3 className="policy-section__title">{section.heading}</h3>
      <div className="policy-section__content">{renderContent(section.content)}</div>
    </div>
  );
};

const Policies = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const validIds = policies.map((p) => p.id);
  const tabFromUrl = searchParams.get('tab');

  const [activePolicy, setActivePolicy] = useState(
    validIds.includes(tabFromUrl) ? tabFromUrl : 'shipping'
  );

  // Re-sync whenever the URL's ?tab= changes — e.g. clicking a different
  // footer link (Returns, Privacy, Terms...) while already on this page,
  // since navigating to the same route doesn't remount the component.
  useEffect(() => {
    if (validIds.includes(tabFromUrl) && tabFromUrl !== activePolicy) {
      setActivePolicy(tabFromUrl);
    }
  }, [tabFromUrl]);

  // Scroll back to the top whenever the active tab changes — otherwise
  // switching tabs while scrolled down (e.g. via the footer's Returns &
  // Exchange link, or the sidebar) leaves the shopper looking at whatever
  // content happened to be at that same scroll position on the new tab.
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [activePolicy]);

  // Clicking a sidebar tab also updates the URL, so the address bar / back
  // button and the footer links both stay in sync with what's showing.
  const selectPolicy = (id) => {
    setActivePolicy(id);
    setSearchParams({ tab: id });
  };

  const policy = policies.find((p) => p.id === activePolicy);

  return (
    <div className="policies-page">
      {/* Hero */}
      <section className="inner-hero">
        <div className="inner-hero__content container">
          <span className="about-eyebrow">Transparency First</span>
          <h1 className="inner-hero__title">Our Policies</h1>
          <p className="inner-hero__sub">
            Clear, honest information about how we operate, protect your data, and handle your orders.
          </p>
        </div>
      </section>

      <div className="container policies-body">
        {/* Sidebar nav */}
        <nav className="policies-nav">
          {policies.map((p) => (
            <button
              key={p.id}
              className={`policies-nav-btn ${activePolicy === p.id ? 'active' : ''}`}
              onClick={() => selectPolicy(p.id)}
            >
              <span>{p.icon}</span>
              <span>{p.title}</span>
              <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" className="nav-btn-arrow">
                <path d="M9 18l6-6-6-6"/>
              </svg>
            </button>
          ))}

          <div className="policies-contact-card">
            <p>Have a question about our policies?</p>
            <a
              href="mailto:fcreation08@gmail.com"
              className="btn btn-primary-warm btn-sm"
              style={{ width: '100%', marginTop: 12, textAlign: 'center' }}
            >
              📧 Email Us
            </a>
            <a
              href="https://wa.me/916355592849"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-outline btn-sm"
              style={{ width: '100%', marginTop: 8, textAlign: 'center' }}
            >
              💬 WhatsApp
            </a>
          </div>
        </nav>

        {/* Policy content */}
        <div className="policies-content">
          <div className="policies-content-header">
            <span className="policies-content-icon">{policy.icon}</span>
            <div>
              <h1 className="policies-content-title">{policy.title}</h1>
              <p className="policies-content-updated">Last updated: {policy.lastUpdated}</p>
            </div>
          </div>

          <div className="policies-sections">
            {policy.sections.map((section, i) => (
              <PolicySection key={i} section={section} />
            ))}
          </div>

          {/* Contact footer */}
          <div className="policies-footer-contact">
            <h4>Need help? Contact us directly</h4>
            <div className="policies-footer-contact__links">
              <a href="mailto:fcreation08@gmail.com">📧 fcreation08@gmail.com</a>
              <a href="https://wa.me/916355592849" target="_blank" rel="noopener noreferrer">
                💬 +91 63555 92849
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policies;